/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// document.addEventListener("DOMContentLoaded", function () {
//   var isMobile = window.innerWidth < 768;

//   if (isMobile) {
//     var mobileWrap = document.getElementById("mobileVideoWrap");
//     var mobileVideo = document.getElementById("mobileVideo");

//     if (mobileWrap && mobileVideo) {
//       var videoSrc = mobileVideo.getAttribute("data-src");

//       if (videoSrc) {
//         mobileWrap.style.display = "block";

//         var source = document.createElement("source");
//         source.src = videoSrc;
//         source.type = "video/mp4";

//         mobileVideo.appendChild(source);
//         mobileVideo.load();
//         mobileVideo.play().catch(function (err) {
//           console.warn("Mobile video autoplay blocked:", err);
//         });
//       }
//     }
//   } else {
//     var desktopWrap = document.getElementById("desktopVideoWrap");
//     var desktopVideo = document.getElementById("desktopVideo");

//     if (desktopWrap && desktopVideo) {
//       var videoSrc = desktopVideo.getAttribute("data-src");

//       if (videoSrc) {
//         desktopWrap.style.display = "block";

//         var source = document.createElement("source");
//         source.src = videoSrc;
//         source.type = "video/mp4";

//         desktopVideo.appendChild(source);
//         desktopVideo.load();
//         desktopVideo.play().catch(function (err) {
//           console.warn("Desktop video autoplay blocked:", err);
//         });
//       }
//     }
//   }
// });


$(document).ready(function () {
  $('.block-swatch__radio__cusotm.quia[type="radio"]').on('change', function () {
    console.log("custom working");
    $('.block-swatch.main-block-js').removeClass('selected');

    $(this).closest('.block-swatch.main-block-js').addClass('selected');

    var selectedVariantId = $(this).attr('data-var-id');

    var $form = $('.custom-shopify-product-form');

    $form.find('input[name="id"]').val(selectedVariantId);

    var $bundleInput = $form.find('input[name="items[1][id]"]');
    if ($bundleInput.length) {
        $bundleInput.val(selectedVariantId);
    }
  });
});


(function () {
  function selectFirstOption() {
    if (window.location.search.includes("variant=")) return;

    const radios = document.querySelectorAll('.block-swatch__radio, input[name="option1"], .bundle-radio');
    if (radios.length) {
      radios[0].checked = true;
      radios[0].dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  document.addEventListener("DOMContentLoaded", selectFirstOption);
  window.addEventListener("pageshow", selectFirstOption);
})();


function adjustThumbnailMaxHeight() {
  console.log("resizing")
    const $mainImage = $('.product__media-item.is-selected img');
    const $thumbnailsWrapper = $('.product--thumbnails-left .product__thumbnail-list');

    if (window.innerWidth <= 999) {
      $thumbnailsWrapper.css('max-height', ''); 
      return;
    }

    if ($mainImage.length === 0 || $thumbnailsWrapper.length === 0) return;

    if ($mainImage[0].complete) {
      $thumbnailsWrapper.css('max-height', $mainImage.height() + 'px');
    } else {
      $mainImage.on('load', function () {
        $thumbnailsWrapper.css('max-height', $(this).height() + 'px');
      });
    }
  }
  adjustThumbnailMaxHeight();
  $(window).on('load resize', adjustThumbnailMaxHeight);

function syncComparisonRowHeights() {
  const labelBlock = document.querySelector('.comparison-labels-block');
  const comparisonCols = document.querySelectorAll('.comparison-col');

  // ✅ Check if all required elements exist
  if (!labelBlock || !comparisonCols.length) return;

  const labelRows = [...labelBlock.querySelectorAll('.label-item')];
  const labelTitle = labelBlock.querySelector('.label-title');

  if (!labelTitle || !labelRows.length) return;

  // Clear previous heights
  labelTitle.style.height = 'auto';
  comparisonCols.forEach(col => {
    const title = col.querySelector('.col-title');
    if (title) title.style.height = 'auto';

    const items = col.querySelectorAll('.col-item');
    items.forEach(item => item.style.height = 'auto');
  });

  // --------- 1. Sync Title Row ---------
  let titleHeights = [labelTitle.offsetHeight];

  comparisonCols.forEach(col => {
    const title = col.querySelector('.col-title');
    if (title) titleHeights.push(title.offsetHeight);
  });

  const maxTitleHeight = Math.max(...titleHeights);

  labelTitle.style.height = `${maxTitleHeight}px`;
  comparisonCols.forEach(col => {
    const title = col.querySelector('.col-title');
    if (title) title.style.height = `${maxTitleHeight}px`;
  });

  // --------- 2. Sync Each Label Row with .col-item ---------
  labelRows.forEach((labelRow, index) => {
    let rowHeights = [labelRow.offsetHeight];

    comparisonCols.forEach(col => {
      const items = col.querySelectorAll('.col-item');
      if (items[index]) rowHeights.push(items[index].offsetHeight);
    });

    const maxRowHeight = Math.max(...rowHeights);

    labelRow.style.height = `${maxRowHeight}px`;
    comparisonCols.forEach(col => {
      const items = col.querySelectorAll('.col-item');
      if (items[index]) items[index].style.height = `${maxRowHeight}px`;
    });
  });
}

window.addEventListener('load', syncComparisonRowHeights);
window.addEventListener('resize', () => {
  // Add slight debounce
  clearTimeout(window._resizeTimer);
  window._resizeTimer = setTimeout(syncComparisonRowHeights, 100);
});

$(document).ready(function () {
  new Swiper(".list-collections__list", {
    navigation: {
      prevEl: ".list-collections__list .swiper-button-prev",
      nextEl: ".list-collections__list .swiper-button-next",
    },
    loop: true,
    dot: true,
    slidesPerView: 4,
    spaceBetween: 15,
    paginationClickable: true,
    centeredSlides: false,
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 3,
      },
      544: {
        slidesPerView: 1.3,
        spaceBetween: 12,
      },
      300: {
        slidesPerView: 1.3,
        spaceBetween: 12,
      },
    },
    pagination: {
      el: ".swiper-pagination-collections",
      clickable: true,
    },
  });
  var windowWidth = $(window).width();
  var list_pagination = $(
    ".shopify-section--collection-list .list-collections .swiper-pagination-lock"
  ).length;

  console.log("list_pagination -------", list_pagination);

  if (list_pagination > 0 && windowWidth >= 767 && windowWidth <= 778) {
    $(
      ".shopify-section--collection-list .list-collections .slider-arrow"
    ).hide();
  }

  new Swiper(".before-after-section-content", {
    // Navigation arrows
    navigation: {
      prevEl:
        ".shopify-section--custom-before-after-review .swiper-button-prev",
      nextEl:
        ".shopify-section--custom-before-after-review .swiper-button-next",
    },
    loop: true, // Enable looping
    slidesPerView: 1,
    spaceBetween: 22,
    paginationClickable: true,

    // Disable touch and drag behavior globally
    allowTouchMove: true, // Disable swipe/touch move everywhere
    draggable: true, // Disable dragging by mouse
    touchStartPreventDefault: true, // Prevent default touch actions

    // Breakpoints for responsive behavior
    breakpoints: {
      1200: {
        slidesPerView: 1,
        spaceBetween: 22,
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 22,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 22,
      },
      544: {
        slidesPerView: 1,
        spaceBetween: 22,
      },
      300: {
        slidesPerView: 1,
        spaceBetween: 22,
      },
    },

    // Pagination
    pagination: {
      el: ".swiper-after-before-review",
      clickable: true,
    },
  });

  new Swiper(".if_before_after_reviews .swiper", {
    // Navigation arrows
    navigation: {
      prevEl: ".if_before_after_reviews .swiper-button-prev",
      nextEl: ".if_before_after_reviews .swiper-button-next",
    },
    loop: true, // Enable looping
    slidesPerView: 1,
    spaceBetween: 22,
    paginationClickable: true,

    // Disable touch and drag behavior globally
    allowTouchMove: false, // Disable swipe/touch move everywhere
    draggable: false, // Disable dragging by mouse
    touchStartPreventDefault: false, // Prevent default touch actions

    // Breakpoints for responsive behavior
    breakpoints: {
      1200: {
        slidesPerView: 1,
        spaceBetween: 22,
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 22,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 22,
      },
      544: {
        slidesPerView: 1,
        spaceBetween: 22,
      },
      300: {
        slidesPerView: 1,
        spaceBetween: 22,
      },
    },

    // Pagination
    pagination: {
      el: ".swiper-after-before-review",
      clickable: true,
    },
  });
  new Swiper(".comparison-swiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: ".comparison-swiper .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        spaceBetween: 30,
        slidesPerView: 3,
        pagination: true,
      },
    },
    on: {
      init: syncComparisonRowHeights,
      slideChange: syncComparisonRowHeights,
    },
  });

});

new Swiper(".shopify-section--best-seller .related-products", {
  navigation: {
    prevEl: ".shopify-section--best-seller .swiper-button-prev",
    nextEl: ".shopify-section--best-seller .swiper-button-next",
  },
  loop: false,
  slidesPerView: 4,
  spaceBetween: 15,
  paginationClickable: true,
  centeredSlides: false,
  breakpoints: {
    1200: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 3,
    },
    544: {
      slidesPerView: 2,
    },
    300: {
      slidesPerView: 2,
    },
  },
  pagination: {
    el: ".swiper-pagination-related-products",
    clickable: true,
  },
});

var pagination = $(
  ".shopify-section--best-seller .swiper-pagination-lock"
).length;
if (pagination > 0) {
  $(".shopify-section--best-seller .slider-arrow").hide();
}
const swiper = new Swiper(".tried-tested-video", {
  // Default parameters
  slidesPerView: 5,
  spaceBetween: 8,
  loop: true,
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 3,
    },
    // when window width is >= 640px
    640: {
      slidesPerView: 5,
    },
    1200: {
      slidesPerView: 5,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    prevEl: ".tried-tested-wrapper  .swiper-button-prev",
    nextEl: ".tried-tested-wrapper  .swiper-button-next",
  },
});

// new Swiper(".tried-tested-video", {
//   navigation: {
//     prevEl: ".tried-tested-wrapper  .swiper-button-prev",
//     nextEl: ".tried-tested-wrapper  .swiper-button-next",
//   },
//   loop: true,
//   slidesPerView: 4.7,
//   spaceBetween: 8,
//   paginationClickable: true,
//   centeredSlides: false,
//   breakpoints: {
//     1200: {
//       slidesPerView: 4.7,
//     },
//     1024: {
//       slidesPerView: 3.7,
//     },
//     768: {
//       slidesPerView: 4,
//     },
//     544: {
//       slidesPerView: 2.3,
//       spaceBetween: 8,
//     },
//     300: {
//       slidesPerView: 2.3,
//       spaceBetween: 8,
//     },
//   },
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   },
// });

$(document).on("click", ".tried-tested-video .video-control", function () {
  var clickedControl = $(this);
  var clickedVideo = clickedControl.closest(".popup-video").find("video")[0];
  var videoHtml = clickedControl.closest(".video-item").html();

  // Move the video to the main popup
  $(".tested-main-popup").html(videoHtml);

  // Pause all other videos
  $(".popup-video video")
    .not(clickedVideo)
    .each(function () {
      this.pause();
      $(this).siblings(".video-control").removeClass("btnhide");
    });

  // Toggle play/pause and update control icon for the video in the main popup
  var mainPopupVideo = $(".tested-main-popup video")[0];
  if (mainPopupVideo.paused) {
    mainPopupVideo.play();
    $(".tested-main-popup .video-control").addClass("btnhide");
  } else {
    mainPopupVideo.pause();
    $(".tested-main-popup .video-control").removeClass("btnhide");
  }

  // Activate the main popup
  $(".tested-main-popup").addClass("video-active");
  $("body").addClass("video-popup-active");
});

$(".tried-tested-item").mouseover(function () {
  var mainPopupVideo = $(this).find("video")[0];
  console.log("mainPopupVideo", mainPopupVideo);
  mainPopupVideo.play();
});

$(".tried-tested-item").mouseleave(function () {
  var mainPopupVideo = $(this).find("video")[0];
  console.log("mainPopupVideo", mainPopupVideo);
  mainPopupVideo.pause();
});

$(document).on("click", ".tested-main-popup .icon-close", function () {
  // Pause and close the video in the main popup
  var mainPopupVideo = $(".tested-main-popup video")[0];
  if (mainPopupVideo) {
    mainPopupVideo.pause();
    $(".tested-main-popup .video-control").removeClass("btnhide");
  }

  $("body").removeClass("video-popup-active");
  $(".tested-main-popup").removeClass("video-active");
  $(".tested-main-popup").empty();
});

$(document).on("click", ".tried-tested-item .show .icon-volume", function () {
  console.log("this = ", this);
  var mainPopupVideo = $(this).parents(".tried-tested-item").find("video")[0];
  console.log("mainPopupVideo", mainPopupVideo);
  if (mainPopupVideo) {
    mainPopupVideo.muted = !mainPopupVideo.muted;
    $(this).toggleClass("volume-muted", mainPopupVideo.muted);
  }
});


$(document).on("click", ".product-review-video .video-control", function () {
  var clickedControl = $(this);
  var clickedVideo = clickedControl.closest(".popup-video").find("video")[0];
  var videoHtml = clickedControl.closest(".video-item").html();

  // Move the video to the main popup
  $(".review-main-popup").html(videoHtml);

  // Pause all other videos
  $(".popup-video video")
    .not(clickedVideo)
    .each(function () {
      this.pause();
      $(this).siblings(".video-control").removeClass("btnhide");
    });

  // Toggle play/pause and update control icon for the video in the main popup
  var mainPopupVideo = $(".review-main-popup video")[0];
  if (mainPopupVideo.paused) {
    mainPopupVideo.play();
    $(".review-main-popup .video-control").addClass("btnhide");
  } else {
    mainPopupVideo.pause();
    $(".review-main-popup .video-control").removeClass("btnhide");
  }

  // Activate the main popup
  $(".review-main-popup").addClass("video-active");
  $("body").addClass("video-popup-active");
});

$(document).on("click", ".review-main-popup .icon-close", function () {
  // Pause and close the video in the main popup
  var mainPopupVideo = $(".review-main-popup video")[0];
  if (mainPopupVideo) {
    mainPopupVideo.pause();
    $(".review-main-popup .video-control").removeClass("btnhide");
  }

  $("body").removeClass("video-popup-active");
  $(".review-main-popup").removeClass("video-active");
  $(".review-main-popup").empty();
});

$(document).on("click", ".review-main-popup .icon-volume", function () {
  console.log("this = ", this);
  var mainPopupVideo = $(this).parents(".review-main-popup").find("video")[0];
  console.log("mainPopupVideo", mainPopupVideo);
  if (mainPopupVideo) {
    mainPopupVideo.muted = !mainPopupVideo.muted;
    $(this).toggleClass("volume-muted", mainPopupVideo.muted);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".step-content", {
    navigation: {
      prevEl: ".shopify-section--custom-step-section .swiper-button-prev",
      nextEl: ".shopify-section--custom-step-section .swiper-button-next",
    },
    loop: true,
    slidesPerView: 4,
    spaceBetween: 22,
    centeredSlides: false,
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 3,
      },
      544: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      300: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
    },
    pagination: {
      el: ".swiper-pagination-steps",
      clickable: true,
    },
  });
});

$(document).on("click", ".product-video-block .video-control", function () {
  var checkclass = $(this).hasClass("video-play");
  var clickedControl = $(this).parents(".video-item");
  var otherElement = clickedControl.siblings();
  for (i = 0; i < otherElement.length; i++) {
    var otherDivElement = otherElement[i];
    var othervideo = $(otherDivElement).find("video").get(0);
    if (othervideo) {
      othervideo.pause(); // Now you can call pause() on the DOM element
    }
    var otherVideoControl = $(otherDivElement).find(".video-control");
    otherVideoControl.removeClass("video-play");
  }

  var clickedVideo = clickedControl.find("video")[0];
  if (checkclass) {
    $(this).removeClass("video-play");
    clickedVideo.pause();
  } else {
    $(this).addClass("video-play");
    clickedVideo.play();
  }
  // var videoHtml = clickedControl.find('.show').html();
  // $('.main-product-popup').html(videoHtml);
  // $('.popup-video video').not(clickedVideo).each(function() {
  //    this.pause();
  //    $(this).siblings('.video-control').removeClass('btnhide');
  // });
  // var mainPopupVideo = $('.main-product-popup video')[0];
  // if (mainPopupVideo.paused) {
  //    mainPopupVideo.play();
  //    $('.main-product-popup .video-control').addClass('btnhide');
  // } else {
  //    mainPopupVideo.pause();
  //    $('.main-product-popup .video-control').removeClass('btnhide');
  // }
  // $('.main-product-popup').addClass('video-active');
  // $('body').addClass('video-popup-active');
});

$(document).on("click", ".main-product-popup .icon-close", function () {
  var mainPopupVideo = $(".main-product-popup video")[0];
  if (mainPopupVideo) {
    mainPopupVideo.pause();
    $(".main-product-popup .video-control").removeClass("btnhide");
  }
  $("body").removeClass("video-popup-active");
  $(".main-product-popup").removeClass("video-active");
  $(".main-product-popup").empty();
});

$(document).on("click", ".main-product-popup .icon-volume", function () {
  var mainPopupVideo = $(this).parents(".main-product-popup").find("video")[0];
  if (mainPopupVideo) {
    mainPopupVideo.muted = !mainPopupVideo.muted;
    $(this).toggleClass("volume-muted", mainPopupVideo.muted);
  }
});

// video js for the product page end

// JS for FAQ only one open one time
document.addEventListener("DOMContentLoaded", function () {
  const toggleButtons = document.querySelectorAll(".collapsible-toggle");
  toggleButtons.forEach((button) => {
    button.addEventListener("click", function () {
      toggleButtons.forEach((otherButton) => {
        if (otherButton !== button) {
          otherButton.setAttribute("aria-expanded", "false");
        }
      });
    });
  });
});

// ====== custom image slider start =========
// document.addEventListener("DOMContentLoaded", function () {
//   const sliders = document.querySelectorAll(".custom-image-slider-wrapper");

//   // ✅ Run only if screen is larger than 1024px (desktop/laptop)
//   if (window.innerWidth >= 1024) {
//     sliders.forEach((slider) => {
//       const track = slider.querySelector(".custom-image-slider-track");
//       const dots = slider.querySelectorAll(".dot");

//       function moveToSlide(index) {
//         const translateX = -index * 100;
//         track.style.transform = `translateX(${translateX}%)`;

//         dots.forEach((dot) => dot.classList.remove("active"));
//         if (dots[index]) {
//           dots[index].classList.add("active");
//         }
//       }

//       // Dot hover
//       dots.forEach((dot) => {
//         dot.addEventListener("mouseenter", function () {
//           const index = parseInt(this.getAttribute("data-index"));
//           moveToSlide(index);
//         });
//       });

//       // Image hover zones - ✅ Updated logic
//       slider.addEventListener("mousemove", function (e) {
//         const bounds = slider.getBoundingClientRect();
//         const mouseX = e.clientX - bounds.left;
//         const width = bounds.width;

//         const totalSlides = dots.length;

//         if (totalSlides > 1) {
//           const zoneWidth = width / totalSlides;
//           const index = Math.floor(mouseX / zoneWidth);
//           moveToSlide(index);
//         } else {
//           // Agar sirf 1 image hai to always show first slide
//           moveToSlide(0);
//         }
//       });

//       // Reset on mouse leave
//       slider.addEventListener("mouseleave", function () {
//         moveToSlide(0);
//       });
//     });
//   }
// });
function initCustomSlider() {
  const sliders = document.querySelectorAll(".custom-image-slider-wrapper");

  if (window.innerWidth < 1024) return;

  sliders.forEach((slider) => {
    // Prevent duplicate init
    if (slider.classList.contains("slider-initialized")) return;
    slider.classList.add("slider-initialized");

    const track = slider.querySelector(".custom-image-slider-track");
    const dots = slider.querySelectorAll(".dot");

    if (!track || dots.length === 0) return;

    function moveToSlide(index) {
      const translateX = -index * 100;
      track.style.transform = `translateX(${translateX}%)`;

      dots.forEach((dot) => dot.classList.remove("active"));
      if (dots[index]) dots[index].classList.add("active");
    }

    // Dot hover
    dots.forEach((dot) => {
      dot.addEventListener("mouseenter", function () {
        const index = parseInt(this.getAttribute("data-index"));
        moveToSlide(index);
      });
    });

    // Mouse move
    slider.addEventListener("mousemove", function (e) {
      const bounds = slider.getBoundingClientRect();
      const mouseX = e.clientX - bounds.left;
      const width = bounds.width;

      const totalSlides = dots.length;

      if (totalSlides > 1) {
        const zoneWidth = width / totalSlides;
        const index = Math.floor(mouseX / zoneWidth);
        moveToSlide(index);
      } else {
        moveToSlide(0);
      }
    });

    // Reset
    slider.addEventListener("mouseleave", function () {
      moveToSlide(0);
    });
  });
}

// Initial load
document.addEventListener("DOMContentLoaded", initCustomSlider);

// Shopify dynamic section load (IMPORTANT)
document.addEventListener("shopify:section:load", initCustomSlider);

// Extra safety (AJAX / recommendations load)
const observer = new MutationObserver(() => {
  initCustomSlider();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// ====== custom image slider end =========

// Custom Product popup slider start

$(document).ready(function () {
  let thumbSlider, mainSlider;

  function initializeSliders(startIndex = 0) {
    // Destroy if already initialized
    if (thumbSlider && thumbSlider.destroy) thumbSlider.destroy(true, true);
    if (mainSlider && mainSlider.destroy) mainSlider.destroy(true, true);

    // Re-initialize thumbnail slider
    thumbSlider = new Swiper(".magnifying-popup-thumb-slider", {
      loop: true,
      slidesPerView: 8,
      centeredSlides: false,
      watchSlidesProgress: true,
      breakpoints: {
        1200: {
          slidesPerView: 8,
        },
        1024: {
          slidesPerView: 6,
        },
        768: {
          slidesPerView: 4,
        },
        544: {
          slidesPerView: 4,
        },
        300: {
          slidesPerView: 4,
        },
      },
    });

    // Re-initialize main slider
    mainSlider = new Swiper(".magnifying-popup-main-slider", {
      loop: true,
      slidesPerView: 1,
      centeredSlides: false,
      thumbs: {
        swiper: thumbSlider,
      },
      navigation: {
        nextEl: ".magnifying-wrap-slider .swiper-button-next",
        prevEl: ".magnifying-wrap-slider .swiper-button-prev",
      },
      on: {
        init: function () {
          this.slideToLoop(startIndex, 0); // Navigate to desired index
        },
      },
    });
  }

  // When magnifying button is clicked
  $(".product-zoom-image").click(function () {
    // Only run on desktop
    if ($(window).width() < 1024) return;

    // Show popup
    $(".magnifying-popup").addClass("active");
    $("body").addClass("popup-active");

    let SliderIndex = $(this).attr("data-zoom");

    // Fallback if data-zoom is missing or invalid
    if (typeof SliderIndex === "undefined" || isNaN(SliderIndex)) {
      SliderIndex = 0;
    }

    // Initialize slider with the parsed index
    initializeSliders(parseInt(SliderIndex, 10));
  });

  $(".product__media-list").on("change.flickity", function (event, index) {
    // console.log('Slide changed to index: ' + index);
    $(".product__zoom-button.product-zoom-image").attr("data-zoom", index);
  });

  $(".magnifying-close").click(function () {
    $(".magnifying-popup").removeClass("active");
    $("body").removeClass("popup-active");
  });

  $(document).on("keydown", function (e) {
    if (e.key === "Escape" || e.keyCode === 27) {
      $(".magnifying-popup").removeClass("active");
      $("body").removeClass("popup-active");
    }
  });

  // Shop all filter Cookie set
  $(".filter-category").click(function () {
    var dataFilter = $(this).data("filter");
    document.cookie =
      "dataFilter=" + encodeURIComponent(dataFilter) + "; path=/;";
  });

  // Shop all filter Cookie clear for default shop all
  $(".shop-all-link").click(function () {
    var dataFilter = "Shop All";
    document.cookie =
      "dataFilter=" + encodeURIComponent(dataFilter) + "; path=/;";
  });

  // Collection page tab active
  $(".shop-by-item").click(function () {
    $(this).addClass("active");
    $(this).siblings().removeClass("active");
    var dataCollection = $(this).data("collection");
    var dataCount = $(this).data("count");
    $(`.product-facet__meta-bar-item--count`).text(`${dataCount} products`);
    $(`.product-list .product-list__inner#${dataCollection}`).addClass(
      "active"
    );
    $(`.product-list .product-list__inner#${dataCollection}`)
      .siblings()
      .removeClass("active");
  });

  // shop all collection check the cookie
  var dataFilter = getCookie("dataFilter"); // Get cookie value
  if (dataFilter) {
    $(".shop-by-item").each(function () {
      if ($(this).text().trim() === dataFilter.trim()) {
        $(this).addClass("active");
        $(this).siblings().removeClass("active");

        var dataCollection = $(this).data("collection");
        $(`.product-list .product-list__inner#${dataCollection}`).addClass(
          "active"
        );
        $(`.product-list .product-list__inner#${dataCollection}`)
          .siblings()
          .removeClass("active");
      }
    });
  }
});

$(document).ready(function () {
  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  const collectionFromUrl = pathSegments[pathSegments.length - 1];

  if (collectionFromUrl) {
    const targetTab = $(
      `.shop-by-item[data-collection="${collectionFromUrl}"]`
    );
    if (targetTab.length) {
      targetTab.click();
    }
  } else {
    $(".shop-by-item").first().click();
  }
});

// Custom product popup slider end

/*----------    Custom Cart Drawer          ----------*/

// Upsells start

const cartDrawer = document.querySelector("#mini-cart");

let swiperInstances = new WeakMap();

function initializeSlider($slider) {
  if ($slider.length === 0) return;

  const slideCount = $slider.find(".swiper-slide").length;
  const slidesToShow = slideCount < 3 ? slideCount : 3;

  const swiper = new Swiper($slider[0], {
    slidesPerView: slidesToShow,
    spaceBetween: 10,
    loop: slideCount > 3,
    pagination: {
      el: $slider.find(".swiper-pagination")[0],
      clickable: true,
    },
    navigation: false,
    allowTouchMove: slideCount > 3,
    centeredSlides: false,
  });

  swiperInstances.set($slider[0], swiper);
}

function destroyAndReinitSlider($slider) {
  const existingSwiper = swiperInstances.get($slider[0]);
  if (existingSwiper) {
    existingSwiper.destroy(true, true);
    swiperInstances.delete($slider[0]);
  }
  initializeSlider($slider);
}

function fixSwiperTrackWidth($slider) {
  const track = $slider.find(".swiper-wrapper");
  if (track.length && track.width() === 0) {
    destroyAndReinitSlider($slider);
  }
}

function reinitSlidersIfNeeded() {
  const sliders = [
    { $el: $(".slider-wrapper--mobile.mask"), type: "mobile" },
    { $el: $(".slider-wrapper--desktop.mask"), type: "desktop" },
  ];

  sliders.forEach(({ $el }) => {
    if (!$el.length) return;

    const hasUpsell = $el.find(".upsell_main").length > 0;

    if (hasUpsell) {
      destroyAndReinitSlider($el);
      setTimeout(() => fixSwiperTrackWidth($el), 200);
    } else {
      $el.closest(".cartdrawer_upsell").addClass("hide");
    }
  });
}

function observeCartDrawerSlider() {
  if (!cartDrawer) return;

  let lastIsOpen = false;
  let mutationTimeout;

  const handleSliders = (mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.target.closest('.drawer__content')) {
      continue; 
    }
  }

  const isOpen = cartDrawer.hasAttribute('open');
  console.log('working', isOpen);

  if (isOpen) {
    clearTimeout(mutationTimeout);
    mutationTimeout = setTimeout(() => {
      reinitSlidersIfNeeded();
      lastIsOpen = true;
    }, 500);
  } else {
    lastIsOpen = false;
  }
};

  const observer = new MutationObserver(handleSliders);

observer.observe(cartDrawer, {
  attributes: true,
  childList: true
});

  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (cartDrawer.hasAttribute("open")) {
        reinitSlidersIfNeeded();
      }
    }, 200);
  });
}

observeCartDrawerSlider();

document.addEventListener("cart:refresh", function (event) {
  console.log("cart refreshed");
  setTimeout(() => {
    if (cartDrawer.hasAttribute("open")) {
      reinitSlidersIfNeeded();
    }
  }, 1000);
});

// Upsells End

// Drawer Progress line and Free Gift function start

const freeShippingThreshold = 70;
const freeGiftThreshold = 100;

let freeGiftClicked = false;

function maybeAddFreeGift() {
  const $freeGiftButton = $(".free_gift_product_ajax_cart");
  const $freeGiftContainer = $freeGiftButton.closest(".free-gift-container");

  if (freeGiftClicked) {
    console.log("Free gift already triggered");
    return;
  }

  if ($freeGiftContainer.hasClass("pointer-events-none")) {
    console.log("Free gift container is already inactive");
    return;
  }

  freeGiftClicked = true;
  $freeGiftContainer.addClass("pointer-events-none");
  console.log("Triggering free gift add");
  $freeGiftButton.trigger("click");
  $freeGiftButton.prop("disabled", true);
}

function handleCartMilestones(cartTotal) {
  const $freeGiftButton = $(".free_gift_product_ajax_cart");
  const $freeGiftContainer = $freeGiftButton.closest(".free-gift-container");
  const $upsellGiftText = $(".unlock-upsell-gift-text");
  const $progressBar = $(".progress-bar .progress");
  const giftVariantId = $freeGiftButton.attr("data-variantId");

  const progressPercentage = Math.min(
    (cartTotal / freeGiftThreshold) * 100,
    100
  );
  $progressBar.css("width", `${progressPercentage}%`);

  if (cartTotal >= freeShippingThreshold) {
    $(".first-milestone .milestone-icon").addClass("active");
  } else {
    $(".first-milestone .milestone-icon").removeClass("active");
  }

  if (cartTotal >= freeGiftThreshold) {
    maybeAddFreeGift();
    $upsellGiftText.html(
      `Congrats! You've unlocked your <strong>Free Gift!</strong>`
    );
    $(".second-milestone .milestone-icon").addClass("active");
  } else {
    if ($freeGiftContainer.hasClass("pointer-events-none")) {
      $(".remove-gift--product").trigger("click");
      $freeGiftContainer.removeClass("pointer-events-none");
      freeGiftClicked = false;
    }

    if (cartTotal < freeShippingThreshold) {
      const remainingForShipping = (freeShippingThreshold - cartTotal).toFixed(
        2
      );
      $upsellGiftText.html(
        `You are <i class="money">$${remainingForShipping}</i> away from <strong>Free Shipping!</strong>`
      );
    } else if (
      cartTotal >= freeShippingThreshold &&
      cartTotal < freeGiftThreshold
    ) {
      const remainingForGift = (freeGiftThreshold - cartTotal).toFixed(2);
      $upsellGiftText.html(
        `You are <i class="money" style="font-style: normal;">$${remainingForGift}</i> away from <strong>Free gift</strong> worth <strong>$30</strong>`
      );
    }

    $(".second-milestone .milestone-icon").removeClass("active");
  }
}

// Drawer Progress line and Free Gift function end

function calculateTotalSavings() {
  let totalSavings = 0;
  let totalCompareAtPrice = 0;

  $(".cart__item").each(function () {
    const originalPrice =
      parseFloat($(this).attr("line-item-original-price")) || 0;
    const comparePrice =
      parseFloat($(this).attr("line-item-compare-price")) || 0;
    const finalPrice = parseFloat($(this).attr("line-item-price")) || 0;
    const quantity = parseInt($(this).attr("line-item-quantity")) || 1;

    totalCompareAtPrice += comparePrice * quantity;

    if (comparePrice > finalPrice) {
      const diffCompare = comparePrice - finalPrice;
      const savingsCompare = diffCompare * quantity;
      totalSavings += savingsCompare;
    }

    if (originalPrice > finalPrice) {
      const diffOriginal = originalPrice - finalPrice;
      const savingsOriginal = diffOriginal * quantity;
      totalSavings += savingsOriginal;

      totalCompareAtPrice += diffOriginal * quantity;
    }
  });

  // Update elements on the page
  $("[cart-total-save-amount]").text(`$${totalSavings.toFixed(0)}`);
  $("[data-cart-compare-price]").text(`$${totalCompareAtPrice.toFixed(0)}`);
}

function isCart() {
  return document.URL.includes("/cart");
}

document.addEventListener("cart:updated", function (event) {
  console.log("Cart updated");

  var data = event.detail.cart;
  const cartTotal = data.total_price / 100;
  const cartItemCount = data.item_count;
  if (
    (cartTotal === 0 && cartItemCount > 0) ||
    (cartItemCount === 1 && data.items[0].variant_id === 45194635215019)
  ) {
    $(`.cart__item[data-line-id="45194635215019"]`).addClass("is-removed");
    $.post("/cart/clear.js", function () {
      // location.reload();
    });
    return;
  }
  // handleCartMilestones(cartTotal);
  setTimeout(function () {
    calculateTotalSavings();
  }, 300);
  const insuranceItem = data.items.find(
    (item) => item.variant_id === 45194635215019
  );
  $("#insuranceCheckbox").prop("checked", !!insuranceItem);

  // if (!insuranceItem) {
  //     document.cookie = "insurance_opt_out=true; path=/; max-age=" + (60 * 60 * 24); // 1 day
  //   }
});

// Custom remove Function start
$(document).on("click", ".link.main-product--true", function (event) {
  event.preventDefault();
  const $this = $(this);
  const mainItem = $this.closest(".cart__item");
  mainItem
    .find(".line-item__loader, .line-item__loader-spinner")
    .removeAttr("hidden");
  const mainLineId = String($this.data("line-id"));
  const mainQuantity = parseInt(mainItem.attr("line-item-quantity"), 10) || 0;
  console.log(mainLineId);
  
  let giftMultiplier = 1;


  const totalGiftToRemove = mainQuantity * giftMultiplier;
  const updates = {};

  updates[mainLineId] = 0;
  mainItem.addClass("is-removed");

mainItem.find(".cart__item__meta input.freegiftId").each(function () {
  const giftLineId = $(this).val();
  if (giftLineId) {
    const giftItem = $(`.cart__item[data-line-id="${giftLineId}"]`);
    const currentGiftQty =
      parseInt(giftItem.find('input[name="updates[]"]').val(), 10) || 0;

    let quantityToRemove = totalGiftToRemove;
    let newGiftQty = Math.max(0, currentGiftQty - quantityToRemove);

    updates[giftLineId] = newGiftQty;

    if (newGiftQty === 0) {
      giftItem.addClass("is-removed");
    }
  }
});


  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => response.json())
    .then((dataResponse) => {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: dataResponse,
          },
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true })
      );

      $("#mini-cart").removeClass("is-loading");
    })
    .catch((error) => {
      console.error("Error:", error);
      $("#mini-cart").removeClass("is-loading");
    });
});
// Custom remove Function End

function increaseQuantity(event) {
  var updates = { updates: {} };

  var $currentLineItem = $(event).closest(".cart__item");
  var $metaProperties = $currentLineItem.find(".cart__item__info");
  var $quantityInput = $currentLineItem.find(".quantity-selector__input");
  var currentQuantity = parseInt($quantityInput.val(), 10) || 0;
  var newQuantity = currentQuantity + 1;

  $quantityInput.val(newQuantity);

  var mainProductLineId = $(event).data("line-id");
  updates.updates[mainProductLineId] = newQuantity;

  if ($metaProperties.find("input.freegiftId").length > 0) {
    $metaProperties.find("input.freegiftId").each(function () {
      const giftLineId = $(this).val();
      if (!giftLineId) return;

      const giftItem = $(`.cart__item[data-line-id="${giftLineId}"]`);

      updates.updates[giftLineId] = newQuantity;

      giftItem.find('input[name="updates[]"]').val(newQuantity);
    });
  }

  cartUpdated(updates);
  console.log("updates", JSON.stringify(updates));
}




function decreaseQuantity(event) {
  var updates = { updates: {} };

  var $currentLineItem = $(event).closest(".cart__item");
  var $metaProperties = $currentLineItem.find(".cart__item__info");
  var $quantityInput = $currentLineItem.find(".quantity-selector__input");
  var currentQuantity = parseInt($quantityInput.val(), 10) || 0;
  var newQuantity = Math.max(0, currentQuantity - 1);

  $quantityInput.val(newQuantity);

  var mainProductLineId = $(event).data("line-id");
  updates.updates[mainProductLineId] = newQuantity;

  if ($metaProperties.find("input.freegiftId").length > 0) {
    $metaProperties.find("input.freegiftId").each(function () {
      const giftLineId = $(this).val();
      if (!giftLineId) return;

      const giftItem = $(`.cart__item[data-line-id="${giftLineId}"]`);

      updates.updates[giftLineId] = newQuantity;

      giftItem.find('input[name="updates[]"]').val(newQuantity);
    });
  }

    cartUpdated(updates);
  console.log("updates", JSON.stringify(updates));
}


// Function to update cart
function cartUpdated(updates) {
  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updates),
  })
    .then((response) => {
      if (response.ok) {
        return response.json().then((dataResponse) => {
          $("#mini-cart").removeClass("is-loading");
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart: dataResponse,
              },
            })
          );
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true })
          );
        });
      } else {
        console.log(response);
        $("#mini-cart").removeClass("is-loading");
        throw new Error("Error updating cart");
      }
    })
    .catch((error) => {
      $("#mini-cart").removeClass("is-loading");
      console.error("Error:", error);
    });
}

$(document).on("click", ".quantity-selector__button.minus", function (event) {
  $("#mini-cart").addClass("is-loading");
  decreaseQuantity($(this));
});

$(document).on("click", ".quantity-selector__button.plus", function (event) {
  $("#mini-cart").addClass("is-loading");
  increaseQuantity($(this));
});

const insuranceVariantId = 45194635215019;

function handleInsuranceToggle(isChecked) {
  const url = isChecked ? `/cart/add.js` : `/cart/change.js`;

  const data = isChecked
    ? { id: insuranceVariantId, quantity: 1 }
    : { id: insuranceVariantId, quantity: 0 };

  $.ajax({
    type: "POST",
    url: url,
    data: data,
    dataType: "json",
    success: function () {
      $("#mini-cart").removeClass("is-loading");
      $.ajax({
        type: "GET",
        url: "/cart.json",
        dataType: "jsonp",
        success: function (dataResponse) {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                cart: dataResponse,
              },
            })
          );
        },
      });
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true })
      );
    },
    error: function (xhr, status, error) {
      console.error("Insurance toggle error:", error);
      $("#cart-drawer").removeClass("is-loading");
    },
  });
}

$(document).on("change", "#mini-cart #insuranceCheckbox", function () {
  let shippingItem = $(`.cart__item[data-line-id="${insuranceVariantId}"]`);
  if (shippingItem.length) {
    shippingItem
      .find(".line-item__loader, .line-item__loader-spinner")
      .removeAttr("hidden");
  }
  const isChecked = $(this).is(":checked");
  if (!isChecked) {
    document.cookie = "insurance_opt_out=true; path=/; max-age=" + 60 * 60 * 24; // 1 day
  }
  handleInsuranceToggle(isChecked);
});

// Shipping insurance prechecked code
function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

document.addEventListener("cart:updated", function (event) {
  if (!getCookie("insurance_opt_out")) {
    var cart = event.detail.cart;
    const $checkbox = $("#insuranceCheckbox");

    const insuranceInCart = cart.items.some(
      (item) => item.variant_id === insuranceVariantId
    );

    const realItems = cart.items.filter(
      (item) => item.variant_id !== insuranceVariantId
    );
    const realItemCount = realItems.length;

    // if (
    //   realItemCount > 0 &&
    //   !insuranceInCart &&
    //   $checkbox.length &&
    //   !$checkbox.is(":checked")
    // ) {
    //   $checkbox.prop("checked", true).trigger("change");
    // }

    if (cart.items.length === 1 && insuranceInCart) {
      $.post(
        "/cart/change.js",
        {
          id: insuranceVariantId,
          quantity: 0,
        },
        function () {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { bubbles: true })
          );
        }
      );
    }
  }
});

/*----------    Custom Cart Drawer End        ----------*/

$(document).ready(function () {
  const miniCart = document.getElementById("mini-cart");

  $(document).on("click", ".buy-now-btn", function () {
    console.log("Click BUY BUTTON");

    var $body = $("body");
    var $popup = $(".upsell-popup");

    $popup.addClass("active");
    $body.addClass("popup_active");
    $("input.product-popup").prop("disabled", false);
  });

  $(document).on(
    "click",
    ".upsell-popup__close, .upsell-popup__decline",
    function (e) {
      e.preventDefault();
      console.log(
        "Click On the 'upsell-popup__close, .upsell-popup__decline' BUTTON"
      );

      var $body = $("body");
      var $popup = $(".upsell-popup");
      var $buyNowBtn = $("button.buy-now-btn");

      $popup.removeClass("active");
      $body.removeClass("popup_active");

      $("input.product-popup").prop("disabled", true);

      const $submitBtn = $(this).closest($popup).find(".product__submit__add");
      if (!$submitBtn.hasClass("clicked")) {
        $submitBtn.addClass("clicked").trigger("click");
        setTimeout(() => $submitBtn.removeClass("clicked"), 2000);
      }

      $buyNowBtn.attr("aria-busy", "true");

      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (cartDrawer.hasAttribute("open")) {
            $buyNowBtn.removeAttr("aria-busy");
            observer.disconnect();
          }
        });
      });

      if (cartDrawer) {
        observer.observe(cartDrawer, { attributes: true });
        setTimeout(() => {
          observer.disconnect();
          $buyNowBtn.removeAttr("aria-busy");
        }, 5000);
      } else {
        $buyNowBtn.removeAttr("aria-busy");
      }
    }
  );

  let shippingProtectionHandled = false;

  async function handleShippingProtection(cart) {
    return new Promise((resolve) => {
      if (shippingProtectionHandled) return resolve();
      shippingProtectionHandled = true;

      const insuranceInCart = cart.items.some(
        (item) => item.variant_id === insuranceVariantId
      );
      const realItems = cart.items.filter(
        (item) => item.variant_id !== insuranceVariantId
      );
      const realItemCount = realItems.length;

      if (
        !getCookie("insurance_opt_out") &&
        realItemCount > 1 &&
        !insuranceInCart
      ) {
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: JSON.stringify({
            id: insuranceVariantId,
            quantity: 1,
          }),
          dataType: "json",
          contentType: "application/json",
          success: function () {
            console.log("Insurance product added to cart.");
            resolve();
          },
          error: function () {
            console.warn("Failed to add insurance product.");
            resolve();
          },
        });
      } else {
        resolve();
      }
    });
  }

  $(document).on(
    "click",
    ".upsell-popup__content .product__submit__add",
    async function (e) {
      e.preventDefault();
      console.log("Click On the 'product__submit__add");
      const btn = this;
      const popup = document.querySelector(".upsell-popup");
      const body = document.body;

      btn.classList.add("is-loading");
      miniCart.classList.add("force-stop");

      const redirectToCheckout = () => {
        if (popup) popup.classList.remove("active");
        body.classList.remove("popup_active");
        btn.classList.remove("is-loading");

        if (miniCart) {
          if (miniCart.hasAttribute("open")) {
            miniCart.removeAttribute("open");
          }
        }
        window.addEventListener("pagehide", () => {
          if (miniCart) {
            miniCart.classList.remove("force-stop");
          }
        });

        // Redirect immediately
        window.location.href = "/checkout";
      };

      const addFormProductToCart = async () => {
       const form = btn.closest("form");
       if (!form) throw new Error("No form found for product submission.");

          const formData = new FormData(form);


          const payload = { items: [] };


          const mainId = formData.get("id");
          const mainQuantity = parseInt(formData.get("quantity"), 10) || 1;
          const mainSellingPlan = formData.get("selling_plan");

          let mainIndex = null;
          if (mainId) {
            const mainItem = {
              id: mainId,
              quantity: mainQuantity,
            };
            if (mainSellingPlan) mainItem.selling_plan = mainSellingPlan;
            payload.items.push(mainItem);
            mainIndex = payload.items.length - 1; 
          }

          
          const baseIndex = payload.items.length;


          const addProp = (obj, key, value) => {
            if (obj.properties === undefined) obj.properties = {};
            if (obj.properties[key] === undefined) {
              obj.properties[key] = value;
            } else if (Array.isArray(obj.properties[key])) {
              obj.properties[key].push(value);
            } else {
              obj.properties[key] = [obj.properties[key], value];
            }
          };

  
          for (const [key, rawValue] of formData.entries()) {
            const value = typeof rawValue === "string" ? rawValue : String(rawValue);

            
            const mItemField = key.match(/^items\[(\d+)]\[(id|quantity|selling_plan)]$/);
            if (mItemField) {
              const origIdx = parseInt(mItemField[1], 10);
              const field = mItemField[2];
              const idx = baseIndex + origIdx; // shift to avoid clobbering main item

              if (!payload.items[idx]) payload.items[idx] = {};
              if (field === "quantity") {
                payload.items[idx][field] = parseInt(value, 10) || 1;
              } else {
                payload.items[idx][field] = value;
              }
              continue;
            }


            const mItemProp = key.match(/^items\[(\d+)]\[properties]\[(.+)]$/);
            if (mItemProp) {
              const origIdx = parseInt(mItemProp[1], 10);
              const propKey = mItemProp[2];
              const idx = baseIndex + origIdx;

              if (!payload.items[idx]) payload.items[idx] = {};
              addProp(payload.items[idx], propKey, value);
              continue;
            }

        
            const mMainProp = key.match(/^properties\[(.+)]$/);
            if (mMainProp && mainIndex !== null) {
              const propKey = mMainProp[1];
              addProp(payload.items[mainIndex], propKey, value);
              continue;
              }
              }


              payload.items = payload.items.filter((item) => item && item.id);


              if (!payload.items.length) {
                throw new Error("No valid items to add to cart.");
              }


              const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify(payload),
              });

              if (!response.ok) {
                let errMsg = "Failed to add product to cart.";
                try {
                  const err = await response.json();
                  if (err && err.description) errMsg = err.description;
                } catch {}
                throw new Error(errMsg);
              }

              console.log("Products added to cart.");
};


      try {
        await addFormProductToCart();
        redirectToCheckout();
      } catch (error) {
        console.error("Error during product submission or redirect:", error);
        btn.classList.remove("is-loading");
        if (miniCart) {
          miniCart.classList.remove("force-stop");
          if ("open" in miniCart) miniCart.open = false;
        }
      }
    }
  );

  window.addEventListener("load", () => {
    if (sessionStorage.getItem("redirectingToCheckout")) {
      if (miniCart) miniCart.classList.remove("force-stop");
      sessionStorage.removeItem("redirectingToCheckout");
    }
  });
});

$(document).ready(function () {
  $(".product-form__quantity.features_block_div .quantity-selector__input").on(
    "input change",
    function () {
      var quantity = $(this).val();
      $(".custom-form--quantity").val(quantity);
    }
  );
});

// The below code is added to prevent the BOGOS app cart refresh issue

const originalConsoleLog = console.log;

console.log = function (message, ...optionalParams) {
  if (
    typeof message === "string" &&
    message.includes("BOGOS track: Can not fetch all body")
  ) {
    setTimeout(function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true })
      );
    }, 300);
  }

  originalConsoleLog.call(console, message, ...optionalParams);
};

// End Code for BOGOS cart refresh issue resolving

if (document.querySelector(".thumbnail_slider")) {
  new Swiper(".thumbnail_slider", {
    direction: "vertical",
    loop: false,
    slidesPerView: 7,
    spaceBetween: 10,
    centeredSlides: false,
    paginationClickable: true,

    breakpoints: {
      1200: {
        slidesPerView: 7,
      },
      1024: {
        slidesPerView: 6,
      },
      999: {
        slidesPerView: 6,
      },
      544: {
        slidesPerView: 1.3,
        spaceBetween: 12,
      },
      300: {
        slidesPerView: 1.3,
        spaceBetween: 12,
      },
    },
    navigation: {
      prevEl: ".custom-thumbnai-slider-top",
      nextEl: ".custom-thumbnai-slider-bottom",
    },
  });
}

// Increase the purchase count

// const buyingQuantities = document.querySelectorAll('.buying_purchase_quantity');

// if (buyingQuantities.length > 0) {

//   // Use a unique key for localStorage
//   const STORAGE_KEY = 'buyingQuantityValue';

//   // Get the stored number or default to 2608
//   let currentNumber = parseInt(localStorage.getItem(STORAGE_KEY)) || 2608;

//   // Function to update all elements in the DOM
//   function updateDOM() {
//     buyingQuantities.forEach(el => {
//       el.textContent = currentNumber;
//     });
//   }

//   // Initial update
//   updateDOM();

//   function increaseNumber() {
//     const increaseBy = Math.floor(Math.random() * 2) + 1; // Random 1 or 2
//     currentNumber += increaseBy;

//     // Update DOM and localStorage
//     updateDOM();
//     localStorage.setItem(STORAGE_KEY, currentNumber);

//     // Wait 5–10 seconds before next update
//     const nextUpdateIn = Math.floor(Math.random() * 5000) + 5000;
//     setTimeout(increaseNumber, nextUpdateIn);
//   }

//   // Start after 3-second initial delay
//   setTimeout(increaseNumber, 3000);
// }
// Increase the purchase count

// const buyingQuantities = document.querySelectorAll(".buying_purchase_quantity");

// if (buyingQuantities.length > 0) {
//   // Use a unique key for localStorage
//   const STORAGE_KEY = "buyingQuantityValue";

//   // Get the stored number or default to 2608
//   let currentNumber = parseInt(localStorage.getItem(STORAGE_KEY)) || 2608;

//   // Function to update all elements in the DOM
//   function updateDOM() {
//     buyingQuantities.forEach((el) => {
//       el.textContent = currentNumber;
//     });
//   }

//   // Initial update
//   updateDOM();

//   function increaseNumber() {
//     const increaseBy = Math.floor(Math.random() * 2) + 1; // Random 1 or 2
//     currentNumber += increaseBy;

//     // Update DOM and localStorage
//     updateDOM();
//     localStorage.setItem(STORAGE_KEY, currentNumber);

//     // Wait 5–10 seconds before next update
//     const nextUpdateIn = Math.floor(Math.random() * 5000) + 5000;
//     setTimeout(increaseNumber, nextUpdateIn);
//   }

//   // Start after 3-second initial delay
//   setTimeout(increaseNumber, 3000);
// }

$(document).on("click", ".product_upsell_add", function () {
  var $button = $(this);
  $button.addClass("loading");
  var dataVaraint = $(this).data("variant");
  addUpsell(dataVaraint, $button);
});

function addUpsell(dataVaraint, $button) {
  $.ajax({
    type: "post",
    url: "/cart/add.js",
    contentType: "application/json",
    dataType: "json",
    data: JSON.stringify({
      id: dataVaraint,
    }),
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
      // $('.mini-cart').prop('open',true);
      $button.removeClass("loading").text("Added");
    },
    error: function () {
      console.log("Can not add Product");
    },
  });
}

$(document).ready(function () {
  $('.option-card input[type="radio"]').on("change", function () {
    $(".option-card").removeClass("selected");

    $(this).closest(".option-card").addClass("selected");

    var selectedVariantId = $(this).val();
    $("input.current-variant-id[name=id]").val(selectedVariantId);
  });
});

const testimonialSwiper = new Swiper(".testimonial-swiper", {
  slidesPerView: 1.2,
  centeredSlides: true,
  spaceBetween: 10,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

// Custom JS From Sections Below

$(document).ready(function () {
  let flkty;

  function collectionSlider() {
    if ($(".collection-tab-part.active .collection_products").length) {
      flkty = new Flickity(".collection-tab-part.active .collection_products", {
        wrapAround: true,
        cellAlign: "center",
        pageDots: true,
        prevNextButtons: true,
      });

      // On slide change
      flkty.on("select", function () {
        const selectedSlide = $(flkty.selectedElement);
        var dataBgColor = selectedSlide.find(".product_image").data("color");
        var dataTextColor = selectedSlide
          .find(".product_image")
          .data("text-color");
        var dataPillsColor = selectedSlide.find(".product_image").data("pills");
        var dataPillsText = selectedSlide
          .find(".product_image")
          .data("pills-text");
        var dataDots = flkty.selectedIndex + 1;
        $(`.slider_arrow_bullets[data-index=${dataDots}]`).addClass("active");
        $(`.slider_arrow_bullets[data-index=${dataDots}]`)
          .siblings()
          .removeClass("active");
        $(
          `.collection-tab-part.active .active_product_data .product_data[data-slideindex='${flkty.selectedIndex}']`
        )
          .addClass("active")
          .siblings()
          .removeClass("active");
        $(".shopify-section--custom-renewed-collection").css(
          "background",
          dataBgColor
        );
        $(
          ".shopify-section--custom-renewed-collection .section__header h3, .shopify-section--custom-renewed-collection .section__header h2, .collection_list_header .collection_header a"
        ).css("color", dataTextColor);
        $(".collection_list_header .collection_header.active").css(
          "background",
          dataPillsColor
        );
        $(".collection_list_header .collection_header").css(
          "border-color",
          dataPillsColor
        );
        $(".collection_list_header .collection_header.active a").css(
          "color",
          dataPillsText
        );
      });
    }
  }

  // Defualt background color set
  var BgColor = $(
    ".collection-tab-part.active .product_card:first-child .product_image"
  ).data("color");
  var TextColor = $(
    ".collection-tab-part.active .product_card:first-child .product_image"
  ).data("text-color");
  var PillsColor = $(
    ".collection-tab-part.active .product_card:first-child .product_image"
  ).data("pills");
  var PillsText = $(
    ".collection-tab-part.active .product_card:first-child .product_image"
  ).data("pills-text");

  $(".shopify-section--custom-renewed-collection").css("background", BgColor);
  $(
    ".shopify-section--custom-renewed-collection .section__header h3, .shopify-section--custom-renewed-collection .section__header h2, .collection_list_header .collection_header a"
  ).css("color", TextColor);
  $(".collection_list_header .collection_header.active").css(
    "background",
    PillsColor
  );
  $(".collection_list_header .collection_header").css(
    "border-color",
    PillsColor
  );
  $(".collection_list_header .collection_header.active a").css(
    "color",
    PillsText
  );

  collectionSlider();

  // Collection tab click
  $(document).on("click", ".collection_header", function (event) {
    $(this).addClass("active");
    $(this).siblings().removeClass("active");
    var dataTab = $(this).attr("id");
    $(`.collection-tab-part[data-id="${dataTab}"]`).addClass("active");
    $(`.collection-tab-part[data-id="${dataTab}"]`)
      .siblings()
      .removeClass("active");

    if (flkty) {
      flkty.destroy();
      flkty = null;
    }

    collectionSlider();

    var TabBgColor = $(
      ".collection-tab-part.active .product_card:first-child .product_image"
    ).data("color");
    var TabTextColor = $(
      ".collection-tab-part.active .product_card:first-child .product_image"
    ).data("text-color");
    var TabPillsColor = $(
      ".collection-tab-part.active .product_card:first-child .product_image"
    ).data("pills");
    var TabPillsText = $(
      ".collection-tab-part.active .product_card:first-child .product_image"
    ).data("pills-text");
    $(
      `.collection-tab-part.active .active_product_data .product_data:first-child`
    )
      .addClass("active")
      .siblings()
      .removeClass("active");

    $(".shopify-section--custom-renewed-collection").css(
      "background",
      TabBgColor
    );
    $(
      ".shopify-section--custom-renewed-collection .section__header h3, .shopify-section--custom-renewed-collection .section__header h2, .collection_list_header .collection_header a"
    ).css("color", TabTextColor);
    $(".collection_list_header .collection_header.active").css(
      "background",
      TabPillsColor
    );
    $(".collection_list_header .collection_header").css(
      "border-color",
      TabPillsColor
    );
    $(".collection_list_header .collection_header.active a").css(
      "color",
      TabPillsText
    );
    $(".slider_arrow_bullets").removeClass("active");
    $(".slider_arrow_bullets:first-child").addClass("active");
  });

  // Make product card clickable to go to its slide
  $(document).on(
    "click",
    ".collection-tab-part.active .product_card",
    function (e) {
      if (!$(this).hasClass("is-selected")) {
        e.preventDefault();
        const index = $(this).index(); // get index of clicked product_card

        if (flkty) {
          flkty.select(index); // flickity go to selected slide
        }
      }
    }
  );

  $(document).on("click", ".flickity-arrow.flickity-button-next", function () {
    $(".flickity-button.flickity-prev-next-button.next").trigger("click");
  });

  $(document).on("click", ".flickity-arrow.flickity-button-prev", function () {
    $(".flickity-button.flickity-prev-next-button.previous").trigger("click");
  });

  $(document).on("click", ".slider_arrow_bullets", function () {
    $(this).addClass("active");
    $(this).siblings().removeClass("active");
    var dataDots = $(this).data("index");

    $(`.flickity-page-dots .dot[aria-label= "Page dot ${dataDots}"]`).trigger(
      "click"
    );
  });
});

$(document).ready(function () {
  $(".tried-tested-item").mouseover(function () {
    var mainPopupVideo = $(this).find("video")[0];
    mainPopupVideo.play();
  });

  $(".tried-tested-item").mouseleave(function () {
    var mainPopupVideo = $(this).find("video")[0];
    mainPopupVideo.pause();
  });

  $(".footer__item-list .footer__item .footer__item-title").click(function () {
    var tab_id = $(this).closest(".footer_links_mobile").attr("id");
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      var tab_data = $(this).siblings(
        '.footer__item-content[data-id="' + tab_id + '"]'
      );
      $(tab_data).removeClass("active");
      $(this).closest(".footer_links_mobile").removeClass("active");
    } else {
      $(this).closest(".footer_links_mobile").addClass("active");
      $(".footer__item-list .footer__item .footer__item-title").removeClass(
        "active"
      );
      $(this).addClass("active");
      $(".footer__item-content").removeClass("active");
      var tab_data = $(this).siblings(
        '.footer__item-content[data-id="' + tab_id + '"]'
      );
      $(tab_data).addClass("active");
    }
  });
});

$(document).on(
  "click",
  ".video-tested-inner .flickity-arrow.flickity-button-next",
  function () {
    $(
      ".video-tested-inner  .flickity-button.flickity-prev-next-button.next"
    ).trigger("click");
  }
);

$(document).on(
  "click",
  ".video-tested-inner .flickity-arrow.flickity-button-prev",
  function () {
    $(
      ".video-tested-inner .flickity-button.flickity-prev-next-button.previous"
    ).trigger("click");
  }
);

$(document).on("click", ".slider_arrow_bullets", function () {
  $(this).addClass("active");
  $(this).siblings().removeClass("active");
  var dataDots = $(this).data("index");

  $(
    `.video-tested-inner .flickity-page-dots .dot[aria-label= "Page dot ${dataDots}"]`
  ).trigger("click");
});

// $(document).ready(function () {
//   if ($(".product-review-video").length) {
//     flkty = new Flickity(".product-review-video", {
//       wrapAround: true,
//       cellAlign: "center",
//       pageDots: true,
//       prevNextButtons: true,
//     });

//     flkty.on("select", function () {
//       var dataDots = flkty.selectedIndex + 1;
//       $(`.slider_arrow_bullets[data-index="${dataDots}"]`).addClass("active");
//       $(`.slider_arrow_bullets[data-index="${dataDots}"]`)
//         .siblings()
//         .removeClass("active");
//     });
//   }
// });

$(document).ready(function () {
  if ($(".product-review-video").length) {
    var flkty = new Flickity('.product-review-video', {
      wrapAround: true,
      cellAlign: 'center', // 👈 centers the selected slide
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      groupCells: false, // 👈 disable grouping to show individual centered items
    });

    // Listen for slide change
   flkty.on('select', function () {
  var selected = flkty.selectedIndex;

  $('.slider_arrow_bullets').removeClass('active');
  $(`.slider_arrow_bullets[data-index="${selected}"]`).addClass('active');
});

    // Custom arrows click
   $('.flickity-button-next').on('click', function () {
  flkty.next();
});

$('.flickity-button-prev').on('click', function () {
  flkty.previous();
});

    // Optional: Dot click to go to specific page
    $(".slider_arrow_bullets").on("click", function () {
      const index = $(this).data("index");
      flkty.select(index);
    });
  }
});

// ----------------------------


$(".moneyback_popup").click(function () {
  appendPopupData();
  $("moneyback-drawer").attr("open", "");
  $("body").addClass("moneyback_popup_open");
});

function appendPopupData() {
  $("#moneyback-guarantee-popup").empty();
  var popup_data = $("#popup_content").html();
  $("#moneyback-guarantee-popup").append(popup_data);
}

$(document).on(
  "click",
  "#moneyback-guarantee-popup .popup__close-button",
  function () {
    $("moneyback-drawer").removeAttr("open");
    $("body").removeClass("moneyback_popup_open");
  }
);

$(document).ready(function () {
  $('.subscription-option-js input[type="radio"]').on("change", function () {
    $(".subscription-option-js").removeClass("selected");
    $(this).closest(".subscription-option-js").addClass("selected");
  });

  $('input[name="frequency"]').on("change", function () {
    if ($(".subscribe-save").is(":checked")) {
      const sellingPlanId =
        $("#selling-plan-selector").val() ||
        $('input[name="custom_selling_plan"]').val();

      if (sellingPlanId) {
        $("form.shopify-product-form").each(function () {
          const $form = $(this);
          const $existingInput = $form.find('input[name="selling_plan"]');

          if ($existingInput.length === 0) {
            $("<input>", {
              type: "hidden",
              name: "selling_plan",
              value: sellingPlanId,
            }).appendTo($form);
          } else {
            $existingInput.val(sellingPlanId);
          }
        });
      }
    } else {
      $('input[name="selling_plan"]').remove();
    }
  });

  if ($(".subscribe-save").is(":checked")) {
    const sellingPlanId =
      $("#selling-plan-selector").val() ||
      $('input[name="custom_selling_plan"]').val();

    if (sellingPlanId) {
      $("form.shopify-product-form").each(function () {
        const $form = $(this);
        const $existingInput = $form.find('input[name="selling_plan"]');

        if ($existingInput.length === 0) {
          $("<input>", {
            type: "hidden",
            name: "selling_plan",
            value: sellingPlanId,
          }).appendTo($form);
        } else {
          $existingInput.val(sellingPlanId);
        }
      });
    }
  }
});

$(document).ready(function () {
  setTimeout(function () {
    const swiper = new Swiper(".main-personalization-slider", {
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 1.4,
          spaceBetween: 15,
        },
        1200: {
          slidesPerView: 2.5,
          spaceBetween: 25,
        },
      },
      on: {
        init: function () {
          updateArrowVisibility(this);
          updateGradientClasses(this);
        },
        slideChange: function () {
          updateArrowVisibility(this);
          updateGradientClasses(this);
        },
      },
    });

    function updateArrowVisibility(swiperInstance) {
      const prevBtn = document.querySelector(".swiper-button-prev");
      const nextBtn = document.querySelector(".swiper-button-next");

      if (window.innerWidth >= 768) {
        if (swiperInstance.isBeginning) {
          prevBtn.classList.add("d-none");
        } else {
          prevBtn.classList.remove("d-none");
        }

        if (swiperInstance.isEnd) {
          nextBtn.classList.add("d-none");
        } else {
          nextBtn.classList.remove("d-none");
        }
      } else {
        prevBtn.classList.remove("d-none");
        nextBtn.classList.remove("d-none");
      }
    }

    function updateGradientClasses(swiperInstance) {
      const sliderEl = document.querySelector(".main-personalization-slider");

      // Reset both gradient classes first
      sliderEl.classList.remove("show-left-gradient", "show-right-gradient");

      if (window.innerWidth >= 768) {
        if (!swiperInstance.isBeginning) {
          sliderEl.classList.add("show-left-gradient");
        }
        if (!swiperInstance.isEnd) {
          sliderEl.classList.add("show-right-gradient");
        }
      }
    }
  }, 1000);
});

$(".skincare-section .btn-wrapper").click(function () {
  $(".Skincare_consern_details").slideUp();
  $("#quiz_step_4").slideDown();
  $(".quiz-step-section .quiz_step_4").addClass("active");
  $("html, body").animate({ scrollTop: 0 }, "slow");
});

$(document).ready(function () {
  // Fifth step: handle form submission in custom form section
  $(".custom-form-section form").submit(function (event) {
    event.preventDefault(); // Prevent default form submission

    // Get user input value
    var user = $('.custom-form-section input[name="quiz_first_name"]').val();

    // Hide the form section
    $(".custom-form-section").slideUp();

    // Show quiz problem and product feature sections
    $(".quiz_problem_section").slideDown();
    $(".quiz_product_features").slideDown(function () {
      // This callback runs after slideDown completes

      // Remove 'last-visible' class from all product lists first
      $(".quiz-product-list").removeClass("last-visible");

      // Find all visible product lists
      const visibleItems = $(".quiz-product-list:visible");

      // Add 'last-visible' class to the last visible product list
      visibleItems.last().addClass("last-visible");
    });

    // Insert user's name in various text sections
    $(".quiz_problem_section .user_name").text(`${user}, `);
    $(".quiz_clinically_proven").slideDown();
    $(".quiz_username").text(`${user}'s `);

    // Hide quiz steps and show sticky ATC section
    $(".quiz_step_section").hide();
    $(".quiz_sticky_ATC").css("display", "flex");

    // Change background color and scroll to top
    $("body").css("background", "#fff");
    $("html, body").animate({ scrollTop: 0 }, "slow");
  });
});

// When the sticky quiz button is clicked, switch views and scroll to top
$(".quiz_sticky_button").click(function () {
  // Hide current quiz sections
  $(".quiz_sticky_ATC").hide();
  $(".quiz_problem_section").hide();
  $(".quiz_product_features").hide();
  $(".quiz_clinically_proven").hide();

  // Show bundle and testimonial sections
  $(".quiz_product_bundle").show();
  $(".testimonial-slider").show();

  // Smooth scroll to top of the page
  $("html, body").animate({ scrollTop: 0 }, "slow");
});

// $(".bundle_btn_ajax").click(function () {
//   $(this).addClass("btn_load");
//   var dataId = $(this).data("var");
//   addToCartAjax(dataId);
// });

// function addToCartAjax(dataId) {
//   $.ajax({
//     url: "/cart/add.js",
//     method: "POST",
//     dataType: "json",
//     data: {
//       id: dataId,
//       quantity: 1,
//     },
//     success: function (response) {
//       window.location.href = "/checkout";
//     },
//     error: function (xhr, status, error) {
//       console.error("Error adding to cart:", error);
//     },
//   });
// }
$(".bundle_btn_ajax").click(function () {
  var $btn = $(this); // store reference
  $btn.addClass("btn_load");

  var dataId = $btn.data("var");
  addToCartAjax(dataId, $btn);
});

function addToCartAjax(dataId, $btn) {
  $.ajax({
    url: "/cart/add.js",
    method: "POST",
    dataType: "json",
    data: {
      id: dataId,
      quantity: 1,
    },
    success: function (response) {
      $btn.removeClass("btn_load"); // remove here
      window.location.href = "/checkout";
    },
    error: function (xhr, status, error) {
      $btn.removeClass("btn_load"); // also remove on error
      console.error("Error adding to cart:", error);
    },
  });
}

const container = document.getElementById('lottie-container');
const scrollWrapper = document.querySelector('.scroll-lottie-wrapper');
const headings = document.querySelectorAll('.video_content_heading');

let animation;
let totalFrames = 0;
let currentFrame = 0;
let targetFrame = 0;

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
let isMobile = window.innerWidth <= 543;
const LERP_EASE = isMobile ? 0.1 : 0.05;
const FRAME_THRESHOLD = 0.5;

function lerp(start, end, amount) {
  return (1 - amount) * start + amount * end;
}

function animateLottie() {
  currentFrame = lerp(currentFrame, targetFrame, LERP_EASE);

  if (Math.abs(currentFrame - targetFrame) < FRAME_THRESHOLD) {
    currentFrame = targetFrame;
  }

  animation.goToAndStop(currentFrame, true);

  let activeIndex = -1;
  headings.forEach((heading, index) => {
    const scrollFrame = parseFloat(heading.dataset.scroll);
    if (currentFrame >= scrollFrame) {
      activeIndex = index;
    }
  });

  headings.forEach((heading, index) => {
    heading.classList.toggle('active', index === activeIndex);
  });

  requestAnimationFrame(animateLottie);
}

// ✅ Use scroll throttling to reduce load on iOS (optional but recommended)
let ticking = false;
function handleScroll() {
  if (!ticking) {
    requestAnimationFrame(() => {
      const rect = scrollWrapper.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      if (rect.top <= windowHeight && rect.bottom >= 0) {
        const scrollDistance = scrollWrapper.offsetHeight - windowHeight;
        const adjustedScrolled = Math.min(Math.max(-rect.top, 0), scrollDistance);
        const scrollPercent = adjustedScrolled / Math.max(scrollDistance, 1);
        targetFrame = Math.min(scrollPercent * totalFrames, totalFrames - 1);
      }

      ticking = false;
    });

    ticking = true;
  }
}

  function initLottie() {
    if (!container) {
      console.warn("Lottie container not found.");
      return;
    }
  if (animation) animation.destroy();

  isMobile = window.innerWidth <= 543;

    const lottieFileURL = container.getAttribute('lottie_file_url');
    const lottieFileURLMobile = container.getAttribute('lottie_file_url_mobile');

  animation = lottie.loadAnimation({ // <-- fixed here
    container: container,
    renderer: isIOS ? 'canvas' : 'svg', // iOS fix
    loop: false,
    autoplay: false,
    path: isMobile ? lottieFileURLMobile : lottieFileURL
  });

  animation.addEventListener('DOMLoaded', () => {
    totalFrames = animation.totalFrames;
    currentFrame = 0;
    targetFrame = 0;
    animation.goToAndStop(0, true);
    animateLottie();
  });
}


// 🧼 Clean-up memory leaks to avoid crashing Safari
window.addEventListener('beforeunload', () => {
  if (animation) animation.destroy();
});

window.addEventListener('scroll', handleScroll);
initLottie();

// 🔄 Reinitialize on mobile/desktop switch
let lastIsMobile = window.innerWidth <= 543;
window.addEventListener('resize', () => {
  const nowIsMobile = window.innerWidth <= 543;
  if (nowIsMobile !== lastIsMobile) {
    lastIsMobile = nowIsMobile;
    initLottie();
  }
});


$(document).ready(function () {

  $('.product-form__option-selector input.bundle-radio').on('change', function () {
    const $form = $('.custom-shopify-product-form.shopify-product-form');
    const $bundleOption = $(this).closest('.bundle-option');

    const variantId = $bundleOption.find('input[type="radio"]:checked').attr('variant-id');

    // Update main product variant ID
    if (variantId) {
      $form.find('input[name="id"]').val(variantId);
    }
    // Get item 3 fields
    const $itemId = $form.find('input[name="items[3][id]"]');
    const $itemQty = $form.find('input[name="items[3][quantity]"]');
    const $itemLineItem = $form.find('input[name="properties[_free gift 1]"]');

    // Only enable if input has class 'bundle-box-3'
    const shouldEnable = $(this).closest(".bundle-option").hasClass('free_product__included');

    // Check existence before trying to update props
    if ($itemId.length && $itemQty.length) {
      $itemId.prop('disabled', !shouldEnable);
      $itemQty.prop('disabled', !shouldEnable);
      $itemLineItem.prop('disabled', !shouldEnable);
    }


    let price = $bundleOption.data('price');
    price = parseFloat(price) / 100;
    console.log(price);

    let installmentPrice = price / 4;

    let formattedPrice = Math.floor(installmentPrice * 100) / 100;
    formattedPrice = formattedPrice.toFixed(2);

    const installmentElement = document.querySelector('.installment-info p');
    if (installmentElement) {
        installmentElement.textContent = `OR 4 monthly payments of $${formattedPrice} with: `;
    }


  });
});



  const sliders = document.querySelectorAll('.feature_blocks');

sliders.forEach((slider) => {
  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;
  let hasDragged = false;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    hasDragged = false;
    startX = e.pageX;
    scrollLeft = slider.scrollLeft;
    slider.classList.add('active');
  });

  slider.addEventListener('mouseleave', () => {
    if (isDown) {
      isDown = false;
      slider.classList.remove('active');
    }
  });

  slider.addEventListener('mouseup', (e) => {
    if (isDown) {
      isDown = false;
      slider.classList.remove('active');
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX;
    const walk = (x - startX) * 1.5;
    if (Math.abs(walk) > 5) hasDragged = true;
    slider.scrollLeft = scrollLeft - walk;
  });
});

  document.addEventListener('variant:changed', function(event) {
    let variant = event.detail.variant;
    let price = variant.price;
    price = parseFloat(price) / 100;
    console.log(price);

    let installmentPrice = price / 4;

    let formattedPrice = Math.floor(installmentPrice * 100) / 100;
    formattedPrice = formattedPrice.toFixed(2);

    const installmentElement = document.querySelector('.installment-info p');
    if (installmentElement) {
        installmentElement.textContent = `OR 4 monthly payments of $${formattedPrice} with: `;
    }
});


$(document).ready(function() {

  // 1. Initialize Swiper Slider
var visibleChangesSwiper = new Swiper('.visible-changes-swiper', {
  slidesPerView: 1,
  slidesPerGroup: 1, 
  spaceBetween: 20,
  loop: false,
  
  
  pagination: { el: '.swiper-pagination', clickable: true },
  navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
  breakpoints: {
    768: {
      slidesPerView: 2,
      slidesPerGroup: 2, 
     
    },
    1200: {
      slidesPerView: 4,
      slidesPerGroup: 4, 
    
    }
  }
});


(() => {
  const containers = document.querySelectorAll('.comparison-container');

  containers.forEach((container) => {
    const afterImg = container.querySelector('.after-img');
    const slider = container.querySelector('.slider');
    const arrows = container.querySelector('.slider-arrows');

    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let isHorizontal = false;

    // Allow vertical scroll by default
    container.style.touchAction = 'pan-y';

    const moveSlide = (e) => {
      if (!isDragging) return;

      const clientX = e.clientX ?? (e.touches ? e.touches[0].clientX : 0);
      const clientY = e.clientY ?? (e.touches ? e.touches[0].clientY : 0);

      const dx = Math.abs(clientX - startX);
      const dy = Math.abs(clientY - startY);

      // detect horizontal intent
      if (!isHorizontal && (dx > 5 || dy > 5)) {
        isHorizontal = dx > dy;
        // once we confirm it's horizontal, lock vertical scroll
        if (isHorizontal) container.style.touchAction = 'none';
      }

      if (!isHorizontal) return; // vertical scroll — do nothing

      e.preventDefault();

      const rect = container.getBoundingClientRect();
      const offset = Math.min(Math.max(clientX - rect.left, 0), rect.width);
      const percent = (offset / rect.width) * 100;

      afterImg.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
      slider.style.left = `${percent}%`;
      arrows.style.left = `${percent}%`;
    };

    const endSlide = () => {
      if (!isDragging) return;
      isDragging = false;
      isHorizontal = false;
      container.classList.remove('dragging');
      container.style.touchAction = 'pan-y'; // restore vertical scroll

      window.removeEventListener('pointermove', moveSlide);
      window.removeEventListener('pointerup', endSlide);
    };

    const startSlide = (e) => {
      // Only start drag if pointer is on handle or arrows
      if (e.target !== slider && e.target !== arrows) return;

      e.stopPropagation();
      e.preventDefault();

      const first = e.touches ? e.touches[0] : e;
      startX = first.clientX;
      startY = first.clientY;
      isDragging = true;
      isHorizontal = false;
      container.classList.add('dragging');

      // while dragging, block Swiper's drag
      const swiperEl = container.closest('.visible-changes-swiper');
      if (swiperEl && swiperEl.swiper) swiperEl.swiper.allowTouchMove = false;

      window.addEventListener('pointermove', moveSlide, { passive: false });
      window.addEventListener('pointerup', (ev) => {
        endSlide(ev);
        if (swiperEl && swiperEl.swiper) swiperEl.swiper.allowTouchMove = true;
      }, { once: true });
    };

    [slider, arrows].forEach((el) => {
      el.addEventListener('pointerdown', startSlide);
    });
  });
})();


 
});